export default __webpack_public_path__ + "static/media/Griffin_Miller_AHV_In_Moms_We_Trust.15cd71ba.jpg";